module.exports = __webpack_public_path__ + "static/img/lanhai.8b17d43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/2020/pc/lanhai.png
// module id = Hdmh
// module chunks = 69